import { get } from 'lodash';
import { api } from 'utils/hooks/useApi';
import { IPractitionerForm, IPractitioner } from './_types';

const BASE_URL = '/portal-api/v1/practitioner';

export const createPractitioner = async (
  data: IPractitionerForm,
): Promise<IPractitioner | null> => {
  const response = await api().put(`${BASE_URL}/create`, data);
  return get(response, 'data', null);
};

export const updatePractitioner = async (
  data: IPractitionerForm,
): Promise<IPractitioner | null> => {
  const response = await api().post(`${BASE_URL}/update`, data);
  return get(response, 'data', null);
};

export const getPractitioner = async (id: number): Promise<IPractitioner | false> =>
  api()
    .get(`${BASE_URL}/get`, { params: { id } })
    .then((response) => get(response, 'data'))
    .catch(() => false);

export const searchPractitioners = async (searchCriteria: any): Promise<IPractitioner[] | false> =>
  api()
    .post(`${BASE_URL}/search`, searchCriteria)
    .then((response) => get(response, 'data'))
    .catch(() => false);

export const deletePractitioner = async (id: number): Promise<boolean> =>
  api()
    .delete(`${BASE_URL}/delete`, { params: { id } })
    .then(() => true)
    .catch(() => false);
